import { render, staticRenderFns } from "./RequestListItem.vue?vue&type=template&id=fde6dd7c&scoped=true&"
import script from "./RequestListItem.vue?vue&type=script&lang=js&"
export * from "./RequestListItem.vue?vue&type=script&lang=js&"
import style0 from "./RequestListItem.vue?vue&type=style&index=0&id=fde6dd7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde6dd7c",
  null
  
)

export default component.exports